/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import urlUtil from 'scripts/utils/url';
import cloudinaryConfig from 'scripts/config-cloudinary';
import CloudinaryCore from 'cloudinary-core';

const cloudinary = CloudinaryCore.Cloudinary.new(cloudinaryConfig);

export default {
    getCloudinaryPath: function (id, width, height, crop) {
        if (!id) {
            return '';
        }

        var config = {
            fetch_format: 'auto',
            width: width,
            height: height,
            crop: crop || 'fill',
            quality: 'auto',
            flags: 'lossy'
        };

        config.dpr = this.getImageDpr() || config.dpr;

        return this.getImagePath(id, config);
    },

    getImagePath: function (path, config) {
        if (urlUtil.isFullPath(path)) {
            path = this.extendImagePath(path, config);
        } else {
            path = cloudinary.url(path, config);
        }
        return path;
    },

    extendImagePath: function (path, config) {
        var delimiter = '/upload/';
        var splitted = path.split(delimiter);
        var arrLength = splitted.length;
        var options = cloudinary.transformation_string(config) + '/';

        if (arrLength === 1) {
            return path;
        }

        path = [splitted[0], delimiter, options, splitted[1]];

        if (arrLength > 2) {
            for (var i = 2; i < arrLength; i++) {
                path.push(delimiter);
                path.push(splitted[i]);
            }
        }

        return path.join('');
    },

    getImageDpr: function () {
        var dpr = cloudinary.device_pixel_ratio();

        return Math.ceil(+dpr);
    }
};
